// Copyright (c) 2015, mobileX Neo
// MIT License. See license.txt

// for translation
neo._ = function(txt, replace, context = null) {
	if (!txt) return txt;
	if (typeof txt != "string") return txt;

	let translated_text = '';

	let key = txt;    // txt.replace(/\n/g, "");
	if (context) {
		translated_text = neo._messages[`${key}:${context}`];
	}

	if (!translated_text) {
		translated_text = neo._messages[key] || txt;
	}

	if (replace && typeof replace === "object") {
		translated_text = $.format(translated_text, replace);
	}
	return translated_text;
};

window.__ = neo._;

neo.get_languages = function() {
	if (!neo.languages) {
		neo.languages = [];
		$.each(neo.boot.lang_dict, function(lang, value) {
			neo.languages.push({ label: lang, value: value });
		});
		neo.languages = neo.languages.sort(function(a, b) {
			return a.value < b.value ? -1 : 1;
		});
	}
	return neo.languages;
};
